import { createAction, createAsyncThunk } from '@reduxjs/toolkit';

import { set } from '../../utils/request';
import { METHOD_POST } from '../../constants/api';

const resetPassword = createAsyncThunk('auth/resetPassword',
  async (formData = {}, { rejectWithValue }) => {
    try {
      return await set(METHOD_POST, '/reset_password', formData);
    } catch (error) {
      return rejectWithValue(error?.message || 'error on reset password');
    }
  });

export const clearResetPassword = createAction('auth/clearResetPassword');

export default resetPassword;
